import { useEffect } from 'react';
import HardBreak from '@tiptap/extension-hard-break';
import Mention from '@tiptap/extension-mention';
import Placeholder from '@tiptap/extension-placeholder';
import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';

import suggestion from './suggestion';

const MentionsEditor = ({
  value,
  onChange,
  returnType = 'json',
  mentionSuggestions = ['first-name'],
  placeholder = 'Sample Message',
}) => {
  const editor = useEditor({
    extensions: [
      StarterKit.configure({
        hardBreak: false, // Disable hardBreak from StarterKit to use our own
        // Disable all nodes except paragraph
        blockquote: false,
        bulletList: false,
        codeBlock: false,
        heading: false,
        horizontalRule: false,
        listItem: false,
        orderedList: false,
        // Disable all marks
        bold: false,
        code: false,
        italic: false,
        strike: false,
      }),
      HardBreak.configure({
        HTMLAttributes: {
          class: 'my-1',
        },
      }),
      Placeholder.configure({
        placeholder: placeholder,
        emptyEditorClass:
          'cursor-text before:content-[attr(data-placeholder)] before:text-muted-foreground before:absolute before:top-2 before:left-2 before-pointer-events-none',
      }),
      Mention.configure({
        HTMLAttributes: {
          class:
            'bg-muted rounded-[0.4rem] px-[0.3rem] py-[0.1rem] box-decoration-clone after:content-["\x80"]',
        },
        suggestion: {
          ...suggestion,
          items: ({ query }) => suggestion.items({ query, mentionSuggestions }),
        },
      }),
    ],
    content: value,
    editorProps: {
      attributes: {
        class:
          'min-h-[200px] border rounded-md p-2 rounded-[inherit] ring-offset-none focus-visible:outline-none focus-visible:ring-none focus-visible:ring-offset-0 focus-visible:ring-none',
      },
    },
    onUpdate: ({ editor }) => {
      if (returnType === 'json') {
        onChange(editor.getJSON());
      } else if (returnType === 'text') {
        onChange(editor.getText());
      }
    },
  });

  // Add this useEffect to update editor content when value changes
  useEffect(() => {
    if (editor && value) {
      // Only update if the content is different
      if (JSON.stringify(editor.getJSON()) !== JSON.stringify(value)) {
        editor.commands.setContent(value);
      }
    }
  }, [editor, value]);

  return <EditorContent className='pb-5 text-sm' editor={editor} />;
};

export default MentionsEditor;
